import React from "react";
import { Route, Routes } from "react-router-dom";
import GlobalStyle from "./assets/globalStyles";
import MainTemplate from "./components/organisms/MainTemplate/MainTemplate";
import Team from "./components/pages/Team/Team";
import Contact from "./components/pages/Contact/Contact";
import FindUs from "./components/pages/FindUs/FindUs";
import Galleries from "./components/pages/Galleries/Galleries";
import OurWorks from "./components/pages/OurWorks/OurWorks";
import Home from "./components/pages/Home/Home";

function App() {
  return (
    <div className="App">
      <GlobalStyle />

      <MainTemplate>
        <Routes>
          <Route path="/" exact element={<Home />} />
          <Route path="/team" element={<Team />} />
          <Route path="/gallery" element={<Galleries />} />
          <Route path="/gallery/:id" element={<OurWorks />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/findus" element={<FindUs />} />
        </Routes>
      </MainTemplate>
    </div>
  );
}

export default App;
